import {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  SelectWrapper,
  InputTextWrapper,
  InputDateWrapper,
  InputTextAreaWrapper,
} from '../../../../../../components/UI/Form/Input'
import {getSupplierById} from '../../../../services'
import {getMasterService, getEnterprise} from '../../../../../central/services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {EnterpriseModel} from '../../../../../central/model'
import {SupplierModel, SelectModel} from '../../../../model'
import {TITLE_FORM_SUPPLIER} from '../../../../util/Constants'
import {initValues} from '../../../../util/values/supplier'
import AditionalCamp from '../../../../../../components/UI/Form/aditionalCamp'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
const Supplier: FC = () => {
  const {setError, setValue} = useFormContext()
  const {currentTabItem} = useLavanderia()
  const [status, setStatus] = useState<SelectModel[]>([])
  const [enterprise, setEnterprise] = useState<SelectModel[]>([])
  const getCompanyList = async () => {
    let obj: EnterpriseModel = {
      isCombo: true,
    }
    const response = await getEnterprise(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: item.nombre,
      direccion: item.direccion1,
    }))
    setEnterprise(mappedSites)
  }

  const getStatusList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoProveedor',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setStatus(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  type SupplierModelKeys = keyof SupplierModel

  const getSupplierByIdValues = async () => {
    const response = await getSupplierById(currentTabItem.idToEdit)
    const data = response.data.data
    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        const key = fieldName as SupplierModelKeys
        if (data.hasOwnProperty(key)) {
          const valueDep = data[key]
          if (valueDep !== null && valueDep !== undefined) {
            if (
              key === 'campoadicionalFec1' ||
              key === 'campoadicionalFec2' ||
              key === 'fechaInicioServicio' ||
              key === 'fechaFinServicio'
            ) {
              if (typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(key, formattedDate)
              }
            } else {
              setValue(key, valueDep)
            }
          } else {
            setValue(key, '')
          }
        }
      }
    }
  }
  useEffect(() => {
    getStatusList()
    getCompanyList()
  }, [])
  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getSupplierByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleGetEnterprise = (e: any) => {
    const value = e ? e : ''
    setValue('empresaId', value.value)
    setValue('razonSocial', value.label)
    setValue('direccion', value.direccion)
    setError('empresaId', {})
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <ContentForm isEdit={false} title={TITLE_FORM_SUPPLIER}>
      <div className='row mt-4'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Empresa'
            name='empresaId'
            data={enterprise}
            disabled={isDisabled}
            onChangeValue={handleGetEnterprise}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Razón Social'
            name='razonSocial'
            textPlaceholder='Escribe la razón social'
            disabled={true}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Dirección'
            name='direccion'
            textPlaceholder='Escribe el año'
            disabled={true}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputDateWrapper
            labelText='Fecha de inicio de servicio'
            name='fechaInicioServicio'
            minValue='1900-01-01'
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputDateWrapper
            labelText='Fecha de fin de servicio'
            name='fechaFinServicio'
            minValue='1900-01-01'
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Estado' name='estado' data={status} required />
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 col-lg-6'>
          <InputTextAreaWrapper labelText='Nota' name='nota' textPlaceholder='Escribe la nota' />
        </div>
      </div>
      <hr className='divider' />
      <AditionalCamp module='lavanderia' />
    </ContentForm>
  )
}

export default Supplier
